import { EventsList } from '../../../components/Events/EventsList'

export const EventsTeamSpacePage = () => <EventsList scope="team_space" />
